import { all_routes } from "../../../feature-module/router/all_routes";
const routes = all_routes;

export const SidebarDataTest = [
  {
    tittle: "Dashboard",
    icon: "layers",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "Dashboard",
        submenu: false,
        showSubRoute: false,
        icon: "school",
        base: "dashboard",
        materialicons: "layers",
        link: "/",
      },
    ],
  },
  {
    tittle: "Lesson Plan",
    icon: "send",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "Lesson Plan",
        submenu: false,
        showSubRoute: false,
        icon: "send",
        base: "submission",
        materialicons: "send",
        // link: '/view-lession-plan',
        // link: "/getBatches/lesson_plan",
        link: "/add-lession-plan",
      },
    ],
  },
  {
    tittle: "Attendance",
    icon: "send",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "Attendance",
        submenu: false,
        showSubRoute: false,
        icon: "send",
        base: "attendance",
        materialicons: "send",
        // link: '/view-lession-plan',
        link: "/add-attendance",
        // link: "/getBatches/attendence",
      },
    ],
  },
  // {
  //   tittle: "Attendance",
  //   icon: "send",
  //   showAsTab: false,
  //   separateRoute: false,
  //   submenuItems: [
  //     {
  //       label: "Attendance",
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: "send",
  //       base: "submission",
  //       materialicons: "send",
  //       link: '/getBatches/attendence',
  //     },
  //   ],
  // },
  {
    tittle: "Training Assessments",
    icon: "layers",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "TOP",
        submenu: true,
        showSubRoute: false,
        icon: "article",
        base: "assessments",
        materialicons: "topic",
        submenuItems: [
          {
            label: "Formation",
            link: routes.addassessments,
            base: "lesson-plan-add",
            base2: "lesson-plan-list",
            base3: "lesson-plan-details",
          },
          {
            label: "Evalution",
            link: routes.viewassessments,
            base: "assessment-upload",
            base2: "assessment-list",
            base3: "assessment-details",
          },
        ],
      },
    ],
  },
  // {
  //   tittle: "Training Interface",
  //   icon: "layers",
  //   showAsTab: false,
  //   separateRoute: false,
  //   submenuItems: [
  //     {
  //       label: "Begin Training",
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: "school",
  //       base: "training",
  //       materialicons: "topic",
  //       // link: `/getBatches/start_training`,
  //       link: `/start-training`,
  //     },
  //   ],
  // },
  {
    tittle: "Submission",
    icon: "send",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "Submission",
        submenu: false,
        showSubRoute: false,
        icon: "send",
        base: "submission",
        materialicons: "send",
        // link: "/getBatches/submission",
        link: "submission",
      },
    ],
  },
  {
    tittle: "Support",
    icon: "help",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "Support",
        submenu: false,
        showSubRoute: false,
        icon: "help",
        base: "submission",
        materialicons: "send",
        link: "/support",
      },
    ],
  },
  {
  tittle: "Report",
  icon: "report-analytics",
  showAsTab: false,
  separateRoute: false,
  submenuItems: [
    {
      label: "Reports",
      submenu: true,
      showSubRoute: false,
      icon: "report-analytics",
      base: "reports",
      submenuItems: [
        {
          label: "Registered User",
          link: "/registered-user-report",
          base: "registered-user-report",
          icon: "users",
        },
        {
          label: "Pre-Training Feedback",
          link: "/pre-training-feedback-reports",
          base: "pre-training-feedback-reports",
          icon: "clipboard-check",
        },
        {
          label: "Food and Room Feedback",
          link: "/food-and-room-feedback-reports",
          base: "pre-training-feedback-reports",
          icon: "clipboard-check",
        },
        {
          label: "Post-Training Feedback",
          link: "/post-training-feedback-reports",
          base: "post-training-feedback-reports",
          icon: "message-feedback",
        },
        {
          label: "Top Submission",
          link: "/top-submissions-reports",
          base: "attendance-reports",
          icon: "calendar-check",
        },
      ],
    },
  ],
},


];
